export const handleError = error => {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const { status, errorCode, message } = error.response.data;
    window.alert(
      `Request failed with status code ${status}, error code ${errorCode}: ${message}`
    );
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.error('Error: No response received from server');
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error(`Error: ${error.message}`);
  }
};
